export enum PaymentForm {
  PAID = 1,
  FREE = 2
}



// WEBPACK FOOTER //
// ./src/app/common/enums/payment-form.enum.ts